<template>
  <v-container fluid>
    <Calendar />
  </v-container>
</template>
<script>
import Calendar from "@/components/MANUTENZIONE/Calendar.vue";
export default {
  name: "CalendarioEventi",
  components: { Calendar },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>